import { render, staticRenderFns } from "./mainHome.vue?vue&type=template&id=112a832c&scoped=true&"
import script from "./mainHome.vue?vue&type=script&lang=js&"
export * from "./mainHome.vue?vue&type=script&lang=js&"
import style0 from "./mainHome.vue?vue&type=style&index=0&id=112a832c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "112a832c",
  null
  
)

export default component.exports